export default __webpack_public_path__ + "static/media/lessons_gray.0087671e.svg";